module.exports = __webpack_public_path__ + "img/icon_tag.8b0a68ba.svg";